import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export default function useUnsubscribe() {
  const { search } = useLocation();
  const params = useMemo(() => new URLSearchParams(search), [search]);
  const urlParams = useMemo(() => {
    if (!params) return [undefined, undefined];
    const keys = params.keys().toArray();
    if (keys.length === 0) return [undefined, undefined];
    return [params.get('email'), params.get('campaign_id')];
  }, [params]);

  const submit = useCallback((email: string, campaignId?: string) => {
    const url = [
      'https://kandauser.app.n8n.cloud/webhook-test/7b60ff70-e20e-4b33-ad49-944abf4d30f7',
      email,
      campaignId ?? '1234',
    ]
      .filter(Boolean)
      .join('/');
    try {
      fetch(url, {
        method: 'POST',
      });
    } catch (err) {
      if (err instanceof Error) {
        // eslint-disable-next-line
        console.warn(err.message);
      }
    }
  }, []);

  const emailRef = useRef<string | undefined>();
  useEffect(() => {
    const [email, campaignId] = urlParams;
    if (!email) return;
    if (emailRef.current === email) return;
    emailRef.current = email;
    submit(email, campaignId as string | undefined);
  }, [urlParams, submit]);
}
